import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../guards/service/auth.service';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { ToastrService } from 'ngx-toastr';
import { DomainService } from '../../domain/domain.service';

@Component({
  selector: 'app-reset-password',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent implements OnInit {

  forgotPasswordForm!: FormGroup;
  passwordValidations = {
    minLength: false,
    hasSpecialChar: false,
    hasUpperLowerCase: false,
    hasNumber: false,
    passwordsMatch: false
  };
  email: any;
  slug: string | null = null;
  communityId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private dataService: FreelancerDataService,
    private router: Router,
    private toastrService: ToastrService,
    private authGuardService: AuthService,
    private route: ActivatedRoute,
    private domainService: DomainService
  ) {}

ngOnInit(): void {
  this.route.paramMap.subscribe(params => {
    this.email = decodeURIComponent(params.get('email') || '');
    this.slug = params.get('slug');
    this.communityId = params.get('communityId');

    if (!this.forgotPasswordForm) this.initializeForgotPasswordForm();
    this.forgotPasswordForm.patchValue({ email: this.email });
  });

  if (!this.forgotPasswordForm) this.initializeForgotPasswordForm();
}


  initializeForgotPasswordForm(): void {
    this.forgotPasswordForm = this.fb.group({
      email: [this.email, [Validators.required, Validators.email]],
      current_password: ['', Validators.required],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required]
    });

    this.forgotPasswordForm.get('password')?.valueChanges.subscribe(() => {
      this.validatePassword();
    });

    this.forgotPasswordForm.get('confirm_password')?.valueChanges.subscribe(() => {
      this.validatePassword();
    });
  }

  validatePassword(): void {
    const password = this.forgotPasswordForm.get('password')?.value || '';
    const confirmPassword = this.forgotPasswordForm.get('confirm_password')?.value || '';

    this.passwordValidations.minLength = password.length >= 8;
    this.passwordValidations.hasSpecialChar = /[\W_]/.test(password);
    this.passwordValidations.hasUpperLowerCase = /[a-z]/.test(password) && /[A-Z]/.test(password);
    this.passwordValidations.hasNumber = /\d/.test(password);
    this.passwordValidations.passwordsMatch = password === confirmPassword;
  }

  changePassword(): void {
    if (!this.forgotPasswordForm.valid) return;

    this.dataService.resetPassword(this.forgotPasswordForm.value).subscribe(
      (res: { data: string }) => {
        this.toastrService.success(res.data);
        if (this.domainService.isCommunityDomain() && this.slug && this.communityId) {
          this.router.navigate([`/${this.slug}/${this.communityId}/login`]);
        } else {
          this.router.navigate(['/login']);
        }
      },
      (err: { error: { error: { description: string } } }) => {
        this.toastrService.warning(err.error.error.description);
      }
    );
  }
  backTosignIn(){
    const slug = localStorage.getItem('slug');
    const communityId = localStorage.getItem('communityId');
  
    if (this.domainService.isCommunityDomain() && slug && communityId) {
      this.router.navigate([`/${slug}/${communityId}/login`]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
